import {createFileRoute, redirect} from '@tanstack/react-router'
import {isAuthenticated} from "../../../../utils/auth.ts";
import {useContext, useEffect} from "react";
import {PatientsContext} from "../../../../context/PatientsContext.tsx";
import Layout from "../../../../components/Layouts/Layout.tsx";
import {RecordingsContext} from "../../../../context/RecordingsContext.tsx";
import SessionDetails from "../../../../components/Sessions/SessionDetails.tsx";

export const Route = createFileRoute('/patients/$patientId/sessions/$sessionId',)({
  beforeLoad: async () => {
    if(!isAuthenticated()) {
      throw redirect({to: '/', replace: true});
    }
  },
  component: RouteComponent,
})

function RouteComponent() {
  const { patientId, sessionId } = Route.useParams();
  const { setActivePatient, activePatient } = useContext(PatientsContext);
  const { setActiveRecording } = useContext(RecordingsContext);
  
  useEffect(() => {
    setActivePatient(Number(patientId));
    setActiveRecording(Number(sessionId));
  }, [patientId, sessionId]);
  
  return (
    <Layout>
      <SessionDetails patient={activePatient}/>
    </Layout>
  );
}
